import React from 'react';

interface ArcChartProps {
    value: number;
    total: number;
    color: string;
    size?: number;
    stroke?: number;
}

export const ArcChart: React.FC<ArcChartProps> = ({ value, total, color, size = 84, stroke = 8 }) => {
    const pct = total > 0 ? value / total : 0;
    const r = (size - stroke) / 2;
    const circ = 2 * Math.PI * r;
    const offset = circ * (1 - pct);
    const cx = size / 2;

    return (
        <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
            <circle cx={cx} cy={cx} r={r} fill="none" stroke={`${color}18`} strokeWidth={stroke} />
            <circle
                cx={cx} cy={cx} r={r} fill="none"
                stroke={color} strokeWidth={stroke}
                strokeDasharray={circ} strokeDashoffset={offset}
                strokeLinecap="round"
                style={{ transition: 'stroke-dashoffset 0.6s ease' }}
            />
        </svg>
    );
};
